"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowDateEdit_1 = require("../../../../../../shared/components/editors/CardRowDateEdit");
var CardRowTimeEdit_1 = require("../../../../../../shared/components/editors/CardRowTimeEdit");
var BonusTournamentEditor = /** @class */ (function (_super) {
    __extends(BonusTournamentEditor, _super);
    function BonusTournamentEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({
                _currency: data.data
            });
        });
        this.SID_BK = this.props.listBonusKindsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                _btkinds: data.data
            });
        });
        this.SID_LB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({
                _brands: data.data
            });
        });
        this.SID_GS = this.props.listGameSet.Subscribe("*", function (id, data) {
            _this.setState({
                _gamesets: data.data
            });
        });
        this.SID_DA = this.props.listDepositAges.Subscribe("*", function (id, data) {
            _this.setState({
                _depages: data.data
            });
        });
        this.SID_PL = this.props.listPlayerLevels.Subscribe("*", function (id, data) {
            _this.setState({
                _levels: data.data
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    description: _item.description,
                    is_req_player_level: _item.is_req_player_level,
                    min_player_level_id: _item.min_player_level_id,
                    min_player_level_title: _item.min_player_level_title,
                    _brands: [],
                    _gamesets: [],
                    _depages: [],
                    _levels: [],
                    _btkinds: [],
                    _currency: [],
                    is_req_deposit_during_age: _item.is_req_deposit_during_age,
                    deposit_age_type_code: _item.deposit_age_type_code,
                    deposit_age_type_title: _item.deposit_age_type_title,
                    is_req_deposit_amount_during_age: _item.is_req_deposit_amount_during_age,
                    cms_gameset_id: _item.cms_gameset_id,
                    cms_gameset_title: _item.cms_gameset_title,
                    number_of_prizes: _item.number_of_prizes,
                    start_day: _item.start_day,
                    start_month: _item.start_month,
                    start_year: _item.start_year,
                    end_day: _item.end_day,
                    end_month: _item.end_month,
                    end_year: _item.end_year,
                    start_hour: _item.start_hour,
                    start_minute: _item.start_minute,
                    start_second: _item.start_second,
                    end_hour: _item.end_hour,
                    end_minute: _item.end_minute,
                    end_second: _item.end_second,
                    max_buys_count: _item.max_buys_count,
                    freespin_count: _item.freespin_count,
                    is_unlimited_buys_count: _item.is_unlimited_buys_count,
                    is_for_developers_only: _item.is_for_developers_only,
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    is_req_min_bet: _item.is_req_min_bet,
                    tournament_kind_code: _item.tournament_kind_code,
                    tournament_kind_title: _item.tournament_kind_title
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование турнира"]);
                    _this.props.listGameSet.LoadDataByBrandAndTournamentCurrency(_this.state.brand_id);
                    _this.props.listPlayerLevels.LoadData(_this.state.brand_id);
                });
            }
        }
        else {
            this.setState({
                title: "",
                brand_id: 0,
                brand_title: "",
                description: "",
                is_req_player_level: false,
                min_player_level_id: 0,
                min_player_level_title: "",
                _brands: [],
                _gamesets: [],
                _depages: [],
                _levels: [],
                _btkinds: [],
                _currency: [],
                is_req_deposit_during_age: false,
                deposit_age_type_code: 0,
                deposit_age_type_title: "",
                is_req_deposit_amount_during_age: false,
                cms_gameset_id: 0,
                cms_gameset_title: "",
                number_of_prizes: 0,
                start_day: 1,
                start_month: 1,
                start_year: 2025,
                end_day: 1,
                end_month: 1,
                end_year: 2030,
                max_buys_count: 1,
                freespin_count: 10,
                start_hour: 0,
                start_minute: 0,
                start_second: 0,
                end_hour: 0,
                end_minute: 0,
                end_second: 0,
                is_unlimited_buys_count: false,
                is_for_developers_only: false,
                app_currency_id: 0,
                app_currency_title: "",
                is_req_min_bet: false,
                tournament_kind_code: 0,
                tournament_kind_title: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание турнира"]);
            });
        }
        this.props.listBrands.LoadData();
        this.props.listDepositAges.LoadData();
        this.props.listBonusKindsAvail.LoadData();
        this.props.listAppCurrency.LoadData();
        this.doReSetRules();
    };
    BonusTournamentEditor.prototype.componentWillUnmount = function () {
        this.props.listBrands.UnSubscribe(this.SID_LB);
        this.props.listGameSet.UnSubscribe(this.SID_GS);
        this.props.listDepositAges.UnSubscribe(this.SID_DA);
        this.props.listPlayerLevels.UnSubscribe(this.SID_PL);
        this.props.listBonusKindsAvail.UnSubscribe(this.SID_BK);
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
    };
    BonusTournamentEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            min_player_level_rules: { isError: false },
            brand_rules: { isError: false },
            cms_gameset_rules: { isError: false },
            deposit_age_type_rules: { isError: false },
            number_of_prizes_rules: { isError: false },
            max_buys_count_rules: { isError: false },
            freespin_count_rules: { isError: false },
            tournament_kind_rules: { isError: false },
            app_currency_rules: { isError: false }
        });
    };
    BonusTournamentEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: { isError: true, errorMessage: "Поле [имя] не заполнено!" },
            });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" },
            });
            return false;
        }
        if ((this.state.cms_gameset_id <= 0) || (this.state.cms_gameset_title.length === 0)) {
            this.setState({
                cms_gameset_rules: { isError: true, errorMessage: "Поле [набор игр] не выбрано!" },
            });
            return false;
        }
        if (this.state.is_req_player_level) {
            if ((this.state.min_player_level_id <= 0) || (this.state.min_player_level_title.length === 0)) {
                this.setState({
                    min_player_level_rules: { isError: true, errorMessage: "Поле [уровень игрока] не выбрано!" },
                });
                return false;
            }
        }
        if (this.state.is_req_deposit_during_age) {
            if ((this.state.deposit_age_type_code <= 0) || (this.state.deposit_age_type_title.length === 0)) {
                this.setState({
                    deposit_age_type_rules: { isError: true, errorMessage: "Поле [период депозита] не выбрано!" },
                });
                return false;
            }
        }
        if (this.state.number_of_prizes <= 0) {
            this.setState({
                number_of_prizes_rules: { isError: true, errorMessage: "Поле [количество призовых мест] указано некорректно!" },
            });
            return false;
        }
        if (!this.state.is_unlimited_buys_count) {
            if (this.state.max_buys_count <= 0) {
                this.setState({
                    max_buys_count_rules: { isError: true, errorMessage: "Поле [количество попыток] указано некорректно!" },
                });
                return false;
            }
        }
        if (this.state.freespin_count <= 0) {
            this.setState({
                freespin_count_rules: { isError: true, errorMessage: "Поле [количество фриспинов] указано некорректно!" },
            });
            return false;
        }
        if ((this.state.tournament_kind_code <= 0) || (this.state.tournament_kind_title.length === 0)) {
            this.setState({
                tournament_kind_rules: { isError: true, errorMessage: "Поле [тип турнира] не выбрано!" },
            });
            return false;
        }
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({
                app_currency_rules: { isError: true, errorMessage: "Поле [валюта расчета ставок] не выбрано!" },
            });
            return false;
        }
        return true;
    };
    BonusTournamentEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                is_req_player_level: this.state.is_req_player_level,
                min_player_level_id: this.state.min_player_level_id,
                is_req_deposit_during_age: this.state.is_req_deposit_during_age,
                deposit_age_type_code: this.state.deposit_age_type_code,
                is_req_deposit_amount_during_age: this.state.is_req_deposit_amount_during_age,
                cms_gameset_id: this.state.cms_gameset_id,
                description: this.state.description,
                number_of_prizes: this.state.number_of_prizes,
                start_day: this.state.start_day,
                start_month: this.state.start_month,
                start_year: this.state.start_year,
                end_day: this.state.end_day,
                end_month: this.state.end_month,
                end_year: this.state.end_year,
                max_buys_count: this.state.max_buys_count,
                freespin_count: this.state.freespin_count,
                start_hour: this.state.start_hour,
                start_minute: this.state.start_minute,
                start_second: this.state.start_second,
                end_hour: this.state.end_hour,
                end_minute: this.state.end_minute,
                end_second: this.state.end_second,
                is_unlimited_buys_count: this.state.is_unlimited_buys_count,
                is_for_developers_only: this.state.is_for_developers_only,
                app_currency_id: this.state.app_currency_id,
                tournament_kind_code: this.state.tournament_kind_code,
                is_req_min_bet: this.state.is_req_min_bet
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Турнир изменен!");
            });
        }
    };
    BonusTournamentEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                title: this.state.title,
                brand_id: this.state.brand_id,
                is_req_player_level: this.state.is_req_player_level,
                min_player_level_id: this.state.min_player_level_id,
                is_req_deposit_during_age: this.state.is_req_deposit_during_age,
                deposit_age_type_code: this.state.deposit_age_type_code,
                is_req_deposit_amount_during_age: this.state.is_req_deposit_amount_during_age,
                cms_gameset_id: this.state.cms_gameset_id,
                description: this.state.description,
                number_of_prizes: this.state.number_of_prizes,
                start_day: this.state.start_day,
                start_month: this.state.start_month,
                start_year: this.state.start_year,
                end_day: this.state.end_day,
                end_month: this.state.end_month,
                end_year: this.state.end_year,
                start_hour: this.state.start_hour,
                start_minute: this.state.start_minute,
                start_second: this.state.start_second,
                end_hour: this.state.end_hour,
                end_minute: this.state.end_minute,
                end_second: this.state.end_second,
                max_buys_count: this.state.max_buys_count,
                freespin_count: this.state.freespin_count,
                is_unlimited_buys_count: this.state.is_unlimited_buys_count,
                is_for_developers_only: this.state.is_for_developers_only,
                app_currency_id: this.state.app_currency_id,
                tournament_kind_code: this.state.tournament_kind_code,
                is_req_min_bet: this.state.is_req_min_bet
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Турнир добавлен!");
            });
        }
    };
    BonusTournamentEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTournamentEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить турнир";
        }
        else {
            return "Изменить турнир";
        }
    };
    BonusTournamentEditor.prototype.getMainContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal, title_rules: { isError: false } }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false },
                        _gamesets: [],
                        cms_gameset_id: 0,
                        cms_gameset_title: "",
                        _levels: [],
                        min_player_level_id: 0,
                        min_player_level_title: ""
                    }, function () {
                        _this.props.listGameSet.LoadDataByBrandAndTournamentCurrency(_this.state.brand_id);
                        _this.props.listPlayerLevels.LoadData(_this.state.brand_id);
                    });
                }, items: this.state._brands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип турнира:", placeholder: "Выберите тип турнира" }, value: { key: this.state.tournament_kind_code, value: this.state.tournament_kind_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        tournament_kind_code: newVal.key,
                        tournament_kind_title: newVal.value,
                        tournament_kind_rules: { isError: false }
                    });
                }, items: this.state._btkinds, required: true, rules: this.state.tournament_kind_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта пересчета:", placeholder: "Выберите валюту пересчета" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.state._currency, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Требовать наличие минимальной ставки", value: this.state.is_req_min_bet, onChecked: function (checked) { _this.setState({ is_req_min_bet: checked }); } }),
            React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Начало турнира(UTC)", placeholder: "Выберите дату начала турнира" }, value: { day: this.state.start_day, month: this.state.start_month, year: this.state.start_year }, onValueChanged: function (year, month, day) {
                    _this.setState({
                        start_day: day,
                        start_month: month,
                        start_year: year
                    });
                } }),
            React.createElement(CardRowTimeEdit_1.default, { texts: { caption: "Начало турнира(UTC)", placeholder: "Выберите время" }, value: { hour: this.state.start_hour, minute: this.state.start_minute, second: this.state.start_second }, onValueChanged: function (hour, minute, second) {
                    _this.setState({
                        start_hour: hour,
                        start_minute: minute,
                        start_second: second
                    });
                } }),
            React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Окончание турнира(UTC)", placeholder: "Выберите дату окончания турнира" }, value: { day: this.state.end_day, month: this.state.end_month, year: this.state.end_year }, onValueChanged: function (year, month, day) {
                    _this.setState({
                        end_day: day,
                        end_month: month,
                        end_year: year
                    });
                } }),
            React.createElement(CardRowTimeEdit_1.default, { texts: { caption: "Окончание турнира(UTC)", placeholder: "Выберите время" }, value: { hour: this.state.end_hour, minute: this.state.end_minute, second: this.state.end_second }, onValueChanged: function (hour, minute, second) {
                    _this.setState({
                        end_hour: hour,
                        end_minute: minute,
                        end_second: second
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Набор игр:", placeholder: "Выберите набор игр" }, value: { key: this.state.cms_gameset_id, value: this.state.cms_gameset_title }, onValueChanged: function (newVal) { _this.setState({ cms_gameset_id: newVal.key, cms_gameset_title: newVal.value, brand_rules: { isError: false } }); }, items: this.state._gamesets, required: true, rules: this.state.cms_gameset_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во фриспинов", placeholder: "Введите количество фриспинов" }, values: { max: 100, min: 1, value: this.state.freespin_count }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_count: newVal,
                        freespin_count_rules: { isError: false }
                    });
                }, required: true, precision: 0, rules: this.state.freespin_count_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Требовать наличие депозита за период", value: this.state.is_req_deposit_during_age, onChecked: function (checked) { _this.setState({ is_req_deposit_during_age: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Давность депозита:", placeholder: "Выберите максимальную давность депозита" }, value: { key: this.state.deposit_age_type_code, value: this.state.deposit_age_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        deposit_age_type_code: newVal.key,
                        deposit_age_type_title: newVal.value,
                        deposit_age_type_rules: { isError: false }
                    });
                }, items: this.state._depages, disabled: !this.state.is_req_deposit_during_age, required: true, rules: this.state.deposit_age_type_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Требовать наличие минимальной суммы депозита за период", value: this.state.is_req_deposit_amount_during_age, onChecked: function (checked) { _this.setState({ is_req_deposit_amount_during_age: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Требовать минимальный уровень игрока", value: this.state.is_req_player_level, onChecked: function (checked) { _this.setState({ is_req_player_level: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Мин. уровень игрока:", placeholder: "Выберите минимальный уровень игрока" }, value: { key: this.state.min_player_level_id, value: this.state.min_player_level_title }, onValueChanged: function (newVal) { _this.setState({ min_player_level_id: newVal.key, min_player_level_title: newVal.value, min_player_level_rules: { isError: false } }); }, items: this.state._levels, disabled: !this.state.is_req_player_level, required: true, rules: this.state.min_player_level_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во призовых мест", placeholder: "Введите количество призовых мест" }, values: { max: 100, min: 1, value: this.state.number_of_prizes }, onValueChanged: function (newVal) {
                    _this.setState({
                        number_of_prizes: newVal,
                        number_of_prizes_rules: { isError: false }
                    });
                }, required: true, precision: 0, rules: this.state.number_of_prizes_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Неограниченное кол-во попыток", value: this.state.is_unlimited_buys_count, onChecked: function (checked) { _this.setState({ is_unlimited_buys_count: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во попыток", placeholder: "Введите количество попыток" }, values: { max: 100, min: 1, value: this.state.max_buys_count }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_buys_count: newVal,
                        max_buys_count_rules: { isError: false }
                    });
                }, required: true, precision: 0, rules: this.state.max_buys_count_rules, disabled: this.state.is_unlimited_buys_count }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Виден только разработчикам", value: this.state.is_for_developers_only, onChecked: function (checked) { _this.setState({ is_for_developers_only: checked }); } }),
            this.getDownButtons()));
    };
    BonusTournamentEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusTournamentEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 1200 }, this.getMainContent()));
    };
    return BonusTournamentEditor;
}(React.Component));
exports.default = BonusTournamentEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/BonusTournamentEditor.tsx
// module id = 2503
// module chunks = 0